export const getPrebidProviderDataKey = {
  keys: (args: { scope: string }) => [args],
}

export const getPrebidSearchSegmentDataKey = {
  keys: (args: { scope: string; searchValue: string }) => [args],
}
